import { Directive, input } from '@angular/core';

import { BaseDirective } from '@valk-nx/core/lib/directives/base/base.directive';

@Directive({
	selector: '[sbRoot]',
	standalone: false,
})
export class StoryblokRootDirective extends BaseDirective {
	_editable = input<string>('');
	_uid = input<string>('');
	component = input<string>('');

	canonical = input<string>('');
	robotsNoIndex = input<boolean>(false);
	robotsNoFollow = input<boolean>(false);

	// Needed to "mute" errors in console
	metaDescription = input<string>('');
	metaTitle = input<string>('');
}
